import React, { Component } from 'react'

import paystackLogo from "../../assets/images/paystack.png"
import flutterwaveLogo from "../../assets/images/flutterwave.png"
import btcLogo from "../../assets/images/btcicon.png"
import visaLogo from "../../assets/images/visalogo.png"
import mastercard from "../../assets/images/mastercard.png"

class PaymentMethod extends Component {
    render() {
        return (
            <div className="payment-method">
                <h1>PAYMENT INTEGRATIONS</h1>
                <div className="payment-icon">
                    <div>
                        <img src={paystackLogo} alt="Paystack logo" />
                    </div>
                    <div>
                        <img src={flutterwaveLogo} alt="Flutterwave logo" />
                    </div>
                    <div>
                        <img src={btcLogo} alt="BTC logo" />
                    </div>
                    <div>
                        <img src={visaLogo} alt="VISA logo" />
                    </div>
                    <div>
                        <img src={mastercard} alt="MasterCard logo" />
                    </div>
                </div>
            </div>
        )
    }
}

export default PaymentMethod;